export default __webpack_public_path__ + "static/media/farming.506ebbb7.png";